module.exports = __webpack_public_path__ + "img/N347-1-EN.0dfeb9fa.png";